import * as React from "react";
import { twMerge } from "tailwind-merge";

const FormWrapper = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={twMerge("space-y-6 w-full lg:w-1/2 xl:w-1/3", className)}
      {...props}
    >
      {props.children}
    </div>
  );
});
FormWrapper.displayName = "FormWrapper";

export { FormWrapper };
